import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges, ViewChild} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Notifications

import { HotToastService } from '@ngneat/hot-toast';
import { BsModalService } from 'ngx-bootstrap/modal';


// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {Observable, Subject} from 'rxjs';
import { DemoService } from 'src/app/demo.service';
import { GlobalFunctionsService } from 'src/app/services/global-functions.service';
import { TimeframeSurcharge } from 'src/app/shared/models/timeframeSurcharges.model';

// Using Loadash in Angular
// ::@ https://edupala.com/how-to-use-lodash-in-angular/
import * as _ from 'lodash';
import * as moment from 'moment';
import { setCurrencyCode } from '@syncfusion/ej2-base';

setCurrencyCode('AUD');


@Component({
  selector: 'app-timeframe-surcharge-details-widget',
  templateUrl: './timeframe-surcharge-details-widget.component.html',
  styleUrls: ['./timeframe-surcharge-details-widget.component.scss']
})
export class TimeframeSurchargeDetailsWidgetComponent implements OnInit {

   @ViewChild('traceForm') traceForm: any;

     showDivDisclaimer = true; // set to true so shows always

    model: any;
    job_types: Object;
    job_type_locations: Object;
    count2: any;
    get_latest_court_id: Object;
    job_type_court: Object;
  
 @Input() widget_size;

    @Input() intialCount = 221;
    @Input() count = this.intialCount;
    // sees if there is a change in myCount
  @Output()
  change: EventEmitter<number> = new EventEmitter<number>();
    job_type: Object;
    job_type_location: Object;
  
  
    @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
    job_service_rules: any;
    subject_service_type: any;
  timeframe_surcharge: any;


  timeUnits: string[] = ['Hours', 'Days', 'Weeks'];
  selectedTimeUnit: string = 'Hours'; // default value
  
  public cValue: string = "#1de4d7";
  @Input('value')
  set value(value: any) {
      this.cValue = value;
  }
  search_model_duration_array: any[];
  duration_seconds: number;
duration_minutes: number;
duration_hours: number;

  constructor(
      private http: HttpClient,
  private _demoService: DemoService,
  private route: ActivatedRoute,
  private router: Router,
  public toastr: HotToastService,
  vcr: ViewContainerRef,
  private modalService: BsModalService, viewRef: ViewContainerRef,
  public gfunc: GlobalFunctionsService
  ) { }

  ngOnInit(): void {
      this.getTimeframeSurcharge(this.count);

      if(this.gfunc.sessionUserLevel <= 4){
        this.toggleDivDisclaimer() // hide disclaimer for admin and staff
      }
    
  }

ngOnChanges(){
      this.getTimeframeSurcharge(this.count);

}

    getTimeframeSurcharge(subject_service_type_id) {
    this._demoService.getTimeframeSurcharge(subject_service_type_id).subscribe(
       data => { 
        this.timeframe_surcharge = data;
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }



toggleDivDisclaimer() {
    this.showDivDisclaimer = !this.showDivDisclaimer;
  }

}
